import classnames from 'classnames';
import React, { SVGProps } from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import css from './defaultIconStyles.css';

type BaseSvgIconProps = IconProps &
    SVGProps<any> & {
        pathD: SVGProps<any>['d'];
        pathTransform?: SVGProps<any>['transform'];
        tooltip?: React.ReactNode;
    };
const BaseSvgIcon = ({
    width = 16,
    height = 16,
    className,
    tooltip,
    onClick,
    pathD,
    pathTransform = '',
    viewBox = '0 0 16 16',
    ...svgProps
}: BaseSvgIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={classnames(css.main, className)}
            onClick={onClick}
            viewBox={viewBox}
            {...svgProps}
        >
            <title>{tooltip}</title>
            {/* this wrapping is also needed for hover styles to apply in lists
             */}
            {/* TODO: move hover styling here as a prop that sets display type - half-shaded unless hovered, solid, etc.*/}
            <g fill="none" fillRule="evenodd">
                <rect width={width} height={height} />
                <path
                    className={css.colored}
                    d={pathD}
                    {...(pathTransform && { transform: pathTransform })}
                />
            </g>
        </svg>
    );
};

export { BaseSvgIcon };
